<template>
  <div id="#add-job-form">
    <section class="table-section" v-if="step == 0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col" style="width:45%"></th>
            <th scope="col" v-if="getManagerUserProfile.employer_basic !== 1">Basic</th>
            <th
              style="white-space: nowrap;"
              scope="col"
              v-if="getManagerUserProfile.employer_sourcing !== 1"
            >
              Sourcing
            </th>
            <th scope="col" v-if="getManagerUserProfile.employer_full_service !== 1">
              Full-Service
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              Job Promotion
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="Your job ad will be featured on Jobshark and promoted through our partner network, including job posting on LinkedIn."
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1"><i class="fas fa-check"></i></td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1">
              <i class="fas fa-check"></i>
            </td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <i class="fas fa-check"></i>
            </td>
          </tr>
          <tr>
            <th scope="row">
              Headhunting / Social Recruiting
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="Our experienced recruiters will personally reach out to suitable candidates to introduce your open position. Our network comprises over 100,000 IT professionals, and we also reach out to candidates through social media and online tech communities."
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1"></td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1">
              <i class="fas fa-check"></i>
            </td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <i class="fas fa-check"></i>
            </td>
          </tr>
          <tr>
            <th scope="row">
              Initial Qualification
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="We will evaluate whether the candidate's skills, background, and expectations meet the requirements for the position. The candidate must also adhere to other conditions, such as office policies, to proceed to the next stage.

"
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1"></td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1">
              <i class="fas fa-check"></i>
            </td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <i class="fas fa-check"></i>
            </td>
          </tr>
          <tr>
            <th scope="row">
              In-depth Qualification / Interviewing
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="Our experienced tech recruiters conduct interviews with the candidates who have reached this stage to assess both their technical and soft skills. We provide you with a report about each candidate who passes, in addition to their CV and other information."
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1"></td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1"></td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <i class="fas fa-check"></i>
            </td>
          </tr>
          <tr>
            <th scope="row">
              Online Programming Tests
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="We can set up an online programming test tailored to your specific technical prerequisites. The tests are time-limited (usually 1-3 hours) and carried out on a third-party online platform to ensure impartiality and enable comparison with other developers. We use rigorous anti-plagiarism tools to prevent cheating.

"
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1"></td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1">
              <i class="fas fa-check"></i>
            </td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <i class="fas fa-check"></i>
            </td>
          </tr>
          <tr>
            <th scope="row">
              Arrange Meetings
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="With Jobshark, you always get verified contact details for all presented candidates. We are also happy to help arrange meetings with qualified candidates if you prefer."
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1"></td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1"></td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <i class="fas fa-check"></i>
            </td>
          </tr>
          <tr>
            <th scope="row">
              Reference Checking
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="Our experienced recruiters can conduct reference checks with previous employers and colleagues. You will receive a report for the reference checks. Alternatively, you can request us to provide you with suitable references who are expecting to be contacted by you."
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1"></td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1"></td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <i class="fas fa-check"></i>
            </td>
          </tr>
          <tr>
            <th scope="row">
              Success-based Recruiting fee
              <a
                tabindex="0"
                class="spanner"
                role="button"
                data-bs-toggle="popover"
                data-bs-trigger="focus"
                data-bs-content="Our model is success-based, meaning the Recruiting fee is only paid once you have hired a candidate. A summary of the fee structure is provided in the next step."
                >?</a
              >
            </th>
            <td v-if="getManagerUserProfile.employer_basic !== 1">Free</td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1">
              {{
                formatPrice(sourcingPlan.price_plan.recruiting_fee) !== 0
                  ? formatPrice(sourcingPlan.price_plan.recruiting_fee)
                  : 'Free'
              }}
              {{ sourcingPlan.price_plan.currency_code }}
            </td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              {{
                formatPrice(fullServicePlan.price_plan.recruiting_fee) !== 0
                  ? formatPrice(fullServicePlan.price_plan.recruiting_fee)
                  : 'Free'
              }}
              {{ fullServicePlan.price_plan.currency_code }}
            </td>
          </tr>
          <tr>
            <th scope="row">Select This Plan</th>
            <td v-if="getManagerUserProfile.employer_basic !== 1">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="flexRadioDefault1"
                  :value="0"
                  v-model="selectedPlan"
                />
                <label class="form-check-label" for="flexRadioDefault1"> </label>
              </div>
            </td>
            <td v-if="getManagerUserProfile.employer_sourcing !== 1">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="flexRadioDefault2"
                  :value="1"
                  v-model="selectedPlan"
                />
                <label class="form-check-label" for="flexRadioDefault2"> </label>
              </div>
            </td>
            <td v-if="getManagerUserProfile.employer_full_service !== 1">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="flexRadioDefault2"
                  :value="2"
                  v-model="selectedPlan"
                />
                <label class="form-check-label" for="flexRadioDefault2"> </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="plan" v-if="selectedPlan == 0">
        <p>
          The <strong>basic plan</strong> is entirely free and includes advertising at jobshark.eu
          and through our partner network.
        </p>
      </div>
      <div class="plan" v-if="selectedPlan == 1">
        <p>
          The <strong>sourcing plan</strong> includes headhunting by our professional tech
          recruiters and additional social media advertising. All applicants are qualified by us,
          meaning you only receive relevant applications. For software development positions, we can
          also offer tailor-made programming tests through an online testing platform.
        </p>
      </div>
      <div class="plan" v-if="selectedPlan == 2">
        <p>
          The <strong>full-service</strong> plan includes headhunting by our expert tech recruiters,
          along with additional promotion on social media. We handle the interview process and
          thoroughly qualify all applicants, providing you with a written presentation about each
          candidate. For software development roles, we can also offer customized programming tests
          through an online platform. Additionally, we’re happy to book meetings with candidates and
          conduct reference checks upon request.
        </p>
      </div>
      <div v-if="step === 0" class="row justify-content-center mt-4">
        <div class="col-6 text-center"></div>
        <div class="col-6 text-end">
          <button
            type="button"
            form="add-for-job"
            class="btn btn-secondary btn-custom next"
            @click="nextFirst()"
          >
            Next
            <i class="fa fa-chevron-right ml-3"></i>
          </button>
        </div>
      </div>
    </section>

    <section v-if="step == 0.5">
      <div class="row justify-content-center pt-4">
        <div class="col-md-11">
          <form submit.prevent>
            <ul class="list-unstyled price-list">
              <li>
                <strong>Starting fee: </strong>
                {{
                  selectedPlan === 1
                    ? `${formatPrice(sourcingPlan.price_plan.starting_fee)} ${
                        sourcingPlan.price_plan.currency_code
                      }`
                    : `${formatPrice(fullServicePlan.price_plan.starting_fee)} ${
                        fullServicePlan.price_plan.currency_code
                      }`
                }}
                per posted job
              </li>
              <li>
                <strong>Recruiting fee:</strong>
                {{
                  selectedPlan === 1
                    ? `${formatPrice(sourcingPlan.price_plan.recruiting_fee)} ${
                        sourcingPlan.price_plan.currency_code
                      }`
                    : `${formatPrice(fullServicePlan.price_plan.recruiting_fee)} ${
                        fullServicePlan.price_plan.currency_code
                      }`
                }}
                per hired candidate
              </li>
              <li>
                <strong>Programming test fee:</strong>
                {{
                  selectedPlan === 1
                    ? `${formatPrice(sourcingPlan.price_plan.programming_test_fee)} ${
                        sourcingPlan.price_plan.currency_code
                      }`
                    : `${formatPrice(fullServicePlan.price_plan.programming_test_fee)} ${
                        fullServicePlan.price_plan.currency_code
                      }`
                }}
                per conducted programming test
              </li>
            </ul>
            <p>
              The Starting fee is invoiced once the job ad is published. The Recruiting fee is
              entirely success-based and is only charged if you hire a candidate we have presented.
              If you choose to use our integrated platform for software development tests, you will
              only be charged for each programming test that an invited candidate completes.
            </p>
          </form>
        </div>
      </div>
    </section>

    <!--     <div class="row" v-if="step >= 1">
      <div class="col-12 col-lg-6 ml-auto mr-auto mb-4 mt-4">
        <div class="multisteps-form__progress">
          <button
            :class="step === 1 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="User Info"
          >
            Step 1
          </button>
          <button
            :class="step === 2 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="Address"
          >
            Step 2
          </button>
          <button
            :class="step === 3 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="Order Info"
          >
            Step 3
          </button>
          <button
            :class="step === 4 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="Comments"
          >
            Step 4
          </button>
          <button
            v-if="
              (selectedPlan === 1 && getManagerUserProfile.employer_sourcing === 2) ||
                (selectedPlan === 2 && getManagerUserProfile.employer_full_service === 2)
            "
            :class="step === 5 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="Comments"
          >
            Step 5
          </button>
          <button
            v-if="
              (selectedPlan === 1 && getManagerUserProfile.employer_sourcing === 2) ||
                (selectedPlan === 2 && getManagerUserProfile.employer_full_service === 2)
            "
            :class="step === 6 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="Comments"
          >
            Step 6
          </button>
        </div>
      </div>
    </div> -->

    <section class="pt-4" v-if="step == 1">
      <div class="row justify-content-center">
        <div class="col-md-11 d-flex">
          <button @click="showModal = true" class="btn btn-primary btn-custom ml-auto text-nowrap">
            Copy Existing Job
          </button>

          <CustomMainModal @close="closeModal" v-show="showModal" modalSize="modal-sm">
            <template v-slot:header>
              <h5>Copy Existing Job</h5>
            </template>

            <div class="form-group m-label-left">
              <select
                class="form-control form-control"
                @change="handleEmployerJobs($event)"
                v-model="selectedJobModel"
                id="empl"
              >
                <option
                  v-if="getManagerJobsDropdown.length === 0"
                  :value="{
                    id: '',
                    title: 'No registered jobs',
                    city: { name: '' },
                    country: { name: '' },
                  }"
                >
                  No registered jobs
                </option>
                <option
                  v-for="job in getManagerJobsDropdown"
                  :key="job.id"
                  :value="{
                    id: job.id,
                    title: job.job_name,
                    city: { name: '' },
                    country: { name: '' },
                  }"
                >
                  {{ job.job_name }}, {{ job.city.name }}
                </option>
              </select>
              <label for="empl">Job</label>
            </div>

            <div class="modal-footer d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-primary btn-custom"
                @click="copyExistingJob"
                :disabled="selectedJobModel ? false : true"
              >
                Copy
              </button>
              <button type="button" class="btn btn-secondary btn-custom" @click="closeModal">
                Cancel
              </button>
            </div>
          </CustomMainModal>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-11">
          <!-- error msg -->
          <Message v-show="errorMessage" class="mt-2" type="error-alert">
            <!-- <h4 slot="heading" class="alert-heading">Something went wrong!</h4> -->
            <p slot="alert-message" class="mb-0">{{ errorMessage }}</p>
          </Message>

          <form submit.prevent>
            <div class="form-group m-label-left isWidth required-fixed-right">
              <input
                type="text"
                v-model.trim="$v.selectedFields.selectedJobTitle.$model"
                @change="stepValidator"
                class="form-control my-3"
                id="job-title"
                :class="{
                  'is-invalid': $v.selectedFields.selectedJobTitle.$error,
                  'is-valid': !$v.selectedFields.selectedJobTitle.$invalid,
                }"
                required
              />
              <label for="job-title">Job title</label>
            </div>

            <div class="form-group m-label-left isWidth">
              <input
                type="text"
                id="street-address"
                v-model="selectedFields.address"
                class="form-control"
                required
              />
              <label for="street-address">Street address</label>
            </div>

            <div class="row">
              <div class="form-group m-label col-md-4">
                <input
                  type="text"
                  id="postal-code"
                  v-model="selectedFields.postal"
                  class="form-control"
                  required
                />
                <label for="postal-code">Postal code</label>
              </div>
              <div class="form-group m-label filter-item col-md-8 required-fixed-city">
                <v-select
                  v-model="selectedFields.selectedCity"
                  @change="stepValidator"
                  label="name"
                  :options="getCitiesListByCountry"
                  :reduce="city => city"
                  :clearable="true"
                  id="city"
                >
                  <template v-slot:no-options>
                    <div style="opacity: 0.5">Please select a country first</div>
                  </template>
                </v-select>
                <label for="city">City</label>
              </div>
            </div>
            <!-- Countries -->
            <div class="form-group filter-item m-label-left isWidth required-fixed-country">
              <v-select
                v-model="$v.selectedFields.selectedCountry.$model"
                @input="fetchCitiesByCountryId"
                @change="stepValidator"
                :options="getAllCountries"
                label="name"
                :reduce="country => country"
                :clearable="true"
                id="country"
                :class="{
                  'is-invalid': $v.selectedFields.selectedCountry.$error,
                  'is-valid': !$v.selectedFields.selectedCountry.$invalid,
                }"
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Sorry, no matching country</div>
                </template>
              </v-select>
              <label for="country">Country</label>
            </div>

            <div class="form-group m-label-left isWidth required-fixed-country">
              <select
                id="employment"
                v-model="selectedFields.selectedEmploymentType"
                @change="stepValidator"
                class="form-select my-3 w-100"
                :class="{
                  'is-invalid': $v.selectedFields.selectedEmploymentType.$error,
                  'is-valid': !$v.selectedFields.selectedEmploymentType.$invalid,
                }"
              >
                <option value="1">Employment</option>
                <option value="2">Self-employment</option>
                <option value="3">Employment / Self-Employment</option>
              </select>
              <label for="employment">Employment type</label>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section class="pt-4" v-if="step === 2">
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="form-group m-label-left isWidth required-fixed-right">
            <input
              id="exp"
              type="text"
              v-model.trim.lazy="$v.selectedFields.selectedExperience.$model"
              @change="stepValidator"
              class="form-control"
              :class="{
                'is-invalid': $v.selectedFields.selectedExperience.$error,
                'is-valid': !$v.selectedFields.selectedExperience.$invalid,
              }"
              aria-describedby="MinimumYearsOfExperienceHelp"
            />
            <label for="exp">Minimum years of experience</label>
          </div>

          <div class="form-group m-label-left isWidth">
            <select
              @change="checkDegree"
              id="degree"
              v-model="selectedFields.selectedDegree"
              class="form-select my-3 w-100"
              style="box-shadow: none"
            >
              <option value="">Not required</option>
              <option :value="1">University</option>
              <option :value="2">Bachelor's degree</option>
              <option :value="3">Master's degree</option>
              <option :value="4">PhD</option>
            </select>
            <label for="degree">Degree</label>
          </div>

          <div class="form-group m-label-left isWidth">
            <input
              :disabled="selectedFields.selectedDegree === ''"
              type="text"
              class="form-control w-100"
              id="degree-field"
              v-model="selectedFields.degreeField"
            />
            <label for="degree-field">Degree field</label>
          </div>

          <div class="form-group m-label-left filter-item">
            <v-select
              v-model="selectedFields.competences"
              @search="oncompetenceSearch"
              label="name"
              :options="getCompetencesFilterList"
              :reduce="comp => comp"
              :clearable="true"
              multiple
              id="add-job-competences"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching && search.length >= 3">
                  No results found for <em>{{ search }}</em
                  >.
                </template>
                <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
              </template>
            </v-select>
            <label for="competences">Required competencies</label>
          </div>

          <div class="form-group m-label-left filter-item">
            <v-select
              v-model="selectedFields.advantageCompetences"
              label="name"
              :options="[...getCompetencesFilterList]"
              :reduce="comp => comp"
              :clearable="true"
              multiple
              id="advantage"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching && search.length >= 3">
                  No results found for <em>{{ search }}</em
                  >.
                </template>
                <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
              </template>
            </v-select>
            <label for="advantage">Advantage competencies</label>
          </div>
          <div class="form-group m-label-left filter-item">
            <v-select
              v-model="selectedFields.languages"
              id="Languages"
              label="name"
              :options="getLanguagesList"
              :reduce="lang => lang"
              :clearable="true"
              multiple
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching && search.length >= 3">
                  No results found for <em>{{ search }}</em
                  >.
                </template>
                <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
              </template>
            </v-select>
            <label for="Languages">Language skills</label>
          </div>
        </div>
      </div>
    </section>

    <span class="pt-4" v-if="step === 3">
      <div class="row justify-content-center mb-4 regen">
        <div class="col-md-11 d-flex">
          <select
            style="width: 175px;"
            class="form-select"
            v-model="selectedFields.selectedLanguageForAi"
          >
            <option value="bg">Bulgarian</option>
            <option value="zh_Hans">Chinese (Simplified)</option>
            <option value="zh_Hant">Chinese (Traditional)</option>
            <option value="cs">Czech</option>
            <option value="da">Danish</option>
            <option value="nl">Dutch</option>
            <option value="en">English</option>
            <option value="fi">Finnish</option>
            <option value="fr">French</option>
            <option value="de">German</option>
            <option value="el">Greek</option>
            <option value="hu">Hungarian</option>
            <option value="it">Italian</option>
            <option value="ja">Japanese</option>
            <option value="ko">Korean</option>
            <option value="no">Norwegian</option>
            <option value="pl">Polish</option>
            <option value="pt">Portuguese</option>
            <option value="ro">Romanian</option>
            <option value="ru">Russian</option>
            <option value="es">Spanish</option>
            <option value="sv">Swedish</option>
            <option value="tr">Turkish</option>
            <option value="uk">Ukrainian</option>
          </select>
          <!--           <v-select
            style="width: 175px;"
            v-model="selectedFields.selectedLanguageForAi"
            id="Languages"
            label="name"
            :options="getLanguagesList"
            :reduce="lang => lang"
            :clearable="false"
          >
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching && search.length >= 3">
                No results found for <em>{{ search }}</em
                >.
              </template>
              <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
            </template>
          </v-select> -->
          <button
            :disabled="isGeneratingAI"
            @click="generateWithAi"
            type="button"
            class="btn btn-primary btn-custom ml-auto text-nowrap"
          >
            Rewrite with AI
          </button>
          <button
            :disabled="isGeneratingAI"
            @click="translateWithAi"
            class="btn btn-primary btn-custom ml-3 text-nowrap"
          >
            Regenerate from Template
          </button>
        </div>
      </div>

      <div class="row justify-content-center" :key="componentKey">
        <div class="col-md-11">
          <Spinner :isLoading="isGeneratingAI" />
          <Editor v-model="jobAdText" />

          <p class="mt-3">
            The job ad description has been generated using a template based on your previous
            inputs. Feel free to edit it manually or paste text from an existing ad. To get the best
            results when using the AI feature to rewrite the ad, make sure all basic information is
            included first.
          </p>
        </div>
      </div>
    </span>

    <section class="pt-4" v-if="step === 4">
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="form-group m-label-left isWidth required-fixed-right">
            <input
              v-model="selectedFields.individiuals"
              id="number"
              type="text"
              class="form-control"
            />
            <label for="number">Number of individuals needed </label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-country">
            <select id="full-time" v-model="selectedFields.duration" class="form-select my-3 w-100">
              <option value="1">Permanent employment</option>
              <option value="2">Time-limited employment</option>
            </select>
            <label for="full-time">Duration</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-country">
            <select id="full-time" v-model="selectedFields.fullTime" class="form-select my-3 w-100">
              <option :value="true">Yes</option>
              <option :value="false">No</option>
            </select>
            <label for="full-time">Full-time</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-country">
            <select
              id="workplace"
              v-model="selectedFields.workplace"
              class="form-select my-3 w-100"
            >
              <option value="1">Onsite</option>
              <option value="2">Hybrid</option>
              <option value="3">Remote</option>
            </select>
            <label for="workplace">Workplace</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-country">
            <select
              id="relocation"
              v-model.trim.lazy="$v.selectedFields.selectedRelocation.$model"
              class="form-select my-3 w-100"
              :class="{
                'is-invalid': $v.selectedFields.selectedRelocation.$error,
                'is-valid': !$v.selectedFields.selectedRelocation.$invalid,
              }"
            >
              <option :value="true">Yes (we assist candidates with relocation)</option>
              <option :value="false">No (we don’t assist candidates with relocation)</option>
            </select>
            <label for="relocation">Relocation</label>
          </div>

          <!--       <div class="form-group">
            <textarea
              placeholder="Add comment for Jobshark"
              v-model="selectedFields.comments"
              class="form-control add-job-comments"
              id="add-job-comments"
              rows="4"
            >
            </textarea>
          </div> -->
        </div>
      </div>
    </section>

    <section class="pt-4" v-if="step === 5">
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div
            v-if="
              getManagerUserProfile && getManagerUserProfile.employer_registration_number === null
            "
            class="form-group m-label-left isWidth required-fixed-right"
          >
            <input v-model="selectedFields.regNumber" id="reg" type="text" class="form-control" />
            <label for="reg">Registration number</label>
          </div>

          <div
            v-if="getManagerUserProfile && getManagerUserProfile.employer_eu_vat_number === null"
            class="form-group m-label-left isWidth"
          >
            <input v-model="selectedFields.vat" id="vat" type="text" class="form-control" />
            <label for="vat"
              ><span style="text-transform: uppercase!important;">EU VAT </span> number</label
            >
          </div>

          <div
            v-if="getManagerUserProfile && getManagerUserProfile.employer_invoice_email === null"
            class="form-group m-label-left isWidth"
          >
            <input
              v-model="selectedFields.invoiceEmail"
              id="invoice"
              type="text"
              class="form-control"
            />
            <label for="invoice">Email for invoices</label>
          </div>

          <div
            class="mb-2"
            v-if="
              getManagerUserProfile && getManagerUserProfile.employer_registration_number === null
            "
          >
            Please enter your company registration number.
          </div>
          <div
            class="mb-2"
            v-if="getManagerUserProfile && getManagerUserProfile.employer_eu_vat_number === null"
          >
            If you're based in the EU, include your EU VAT number for invoicing purposes.
          </div>
          <div
            class="mb-2"
            v-if="getManagerUserProfile && getManagerUserProfile.employer_invoice_email === null"
          >
            Invoices are sent via email. If you'd like them sent to a specific inbox, please provide
            that email address above.
          </div>
        </div>
      </div>
    </section>

    <section class="pt-4" v-if="step === 6">
      <div class="row justify-content-center">
        <div class="row">
          <div class="contract">
            <div class="col-md-12" v-html="previewRecruitingContract()"></div>
            <div class="sign">
              <canvas ref="signaturePad" class="signature-pad"></canvas>
            </div>
            <div
              style="padding-left: 8%; padding-right: 8%; align-items: center; margin-top: 5px;"
              class="d-flex"
            >
              <span style="font-size: 13px;"
                >Sign by drawing your signature in the yellow field</span
              >

              <button class="ms-auto btn btn-secondary" style="font-size: 13px;" @click="clear">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- VALIDATION MESSAGES -->
    <div v-if="$v.selectedFields.selectedJobTitle.$error">
      <div
        v-if="!$v.selectedFields.selectedJobTitle.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        <!-- {{ errorHandler($v.selectedFields.firstName.$error) }} -->
        Title field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedCountry.$error">
      <div
        v-if="!$v.selectedFields.selectedCountry.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Country field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedEmploymentType.$error">
      <div
        v-if="!$v.selectedFields.selectedEmploymentType.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Country field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedExperience.$error">
      <div
        v-if="!$v.selectedFields.selectedExperience.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Minimum Years of Experience field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedRelocation.$error">
      <div
        v-if="!$v.selectedFields.selectedRelocation.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Relocation field is required.
      </div>
    </div>

    <!-- Nav btn's -->
    <div v-if="step > 0 && step !== 0.5" class="row justify-content-center mb-5 mt-4">
      <div class="col-5 text-center">
        <button
          class="btn btn-primary btn-custom w-100 mr-5 prev"
          @click="
            prev();
            stepValidator();
          "
          :disabled="step < 0 || (step === 1 && !canChoose)"
        >
          <i class="fa fa-chevron-left mr-3"></i> Back
        </button>
      </div>
      <div class="col-5 text-center">
        <button
          v-if="step === 6 && signaturePad"
          :disabled="signaturePad._data.length === 0 || isLoading"
          type="submit"
          form="add-for-job"
          class="btn btn-secondary btn-custom w-100 next cs-button"
          @click="submitTemplate()"
        >
          Sign Agreement
        </button>

        <button
          v-if="
            step === 4 &&
              (selectedPlan === 0 ||
                (selectedPlan === 1 && getManagerUserProfile.employer_sourcing === 3) ||
                (selectedPlan === 2 && getManagerUserProfile.employer_full_service === 3))
          "
          type="submit"
          form="add-for-job"
          class="btn btn-secondary btn-custom w-100 next"
          style="white-space: wrap;"
          @click="saveAndPublishAd(1)"
          :disabled="selectedFields.individiuals.length === 0"
        >
          {{ lastButtonText }}
        </button>

        <button
          v-if="
            step !== 6 &&
              (step !== 4 ||
                (selectedPlan === 1 && getManagerUserProfile.employer_sourcing !== 3) ||
                (selectedPlan === 2 && getManagerUserProfile.employer_full_service !== 3))
          "
          type="submit"
          form="add-for-job"
          class="btn btn-secondary btn-custom w-100 next"
          @click="
            next();
            stepValidator();
          "
          :disabled="isNextDisabled || (step === 5 && !selectedFields.regNumber)"
        >
          Next
          <i class="fa fa-chevron-right ml-3"></i>
        </button>
      </div>
    </div>

    <div v-if="step === 0.5" class="row justify-content-center mb-5 mt-4">
      <div class="col-5 text-center">
        <button class="btn btn-primary btn-custom w-100 mr-5 prev" @click="newPrev()">
          <i class="fa fa-chevron-left mr-3"></i> Back
        </button>
      </div>
      <div class="col-5 text-center">
        <button
          type="button"
          form="add-for-job"
          class="btn btn-secondary btn-custom w-100 next"
          @click="newNext()"
        >
          Next
          <i class="fa fa-chevron-right ml-3"></i>
        </button>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Editor from '@/components/common/TextEditor';
import Message from '@/components/AlertMessages/Message';
import CustomMainModal from '../../Modals/CustomMainModal';
import { errorService } from '../../../services/errorService';
import { required, minLength } from 'vuelidate/lib/validators';
import Spinner from '../../common/LoadingSpinner/Spinner';
import { degreeMixin } from '../../../mixins/degreeMixin';
import SignaturePad from 'signature_pad';
import axios from 'axios';

// import format from 'date-fns/format';
// import moment from 'moment';

export default {
  components: {
    Spinner,
    Editor,
    Message,
    CustomMainModal,
  },
  mixins: [degreeMixin],
  props: {
    userProfile: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    isGeneratingAI: false,
    signaturePad: null,
    signature: '',

    languageData: {},
    sourcingPlan: {
      price_plan: {
        starting_fee: '',
      },
    },
    fullServicePlan: {
      price_plan: {
        starting_fee: '',
      },
    },
    lastButtonText: 'Submit',
    canChoose: true,
    selectedJobModel: null,
    selectedPlan: null,
    isLoading: false,
    isReadonly: false,
    componentKey: 0,
    showModal: false,
    hidePassword: true,
    errorMessage: '',
    signIn: false,
    step: 0,
    regenerate: false,
    isGenerating: true,
    citiesList: ['sofia'],
    /* Date data */
    dateFormat: 'D MMM YYYY',
    startDate: '',
    endDate: '',
    isActive: false,
    isLangActive: false,
    isCompetenceActive: false,
    isCompetenceAdvActive: false,
    jobAdText: '',
    employerSelectedOption: [],
    selectedFields: {
      description: '',
      benefits: '',
      website: '',

      competences: [],
      advantageCompetences: [],
      selectedExperience: '',
      languages: [],
      selectExistingJobAd: 'Job Ad',
      selectedEmployer: '',
      selectedJobTitle: '',
      selectedEmploymentType: '1',
      selectedDegree: '',
      selectedRelocation: false,

      comments: '',
      selectedCountry: { id: '', name: '', part_of_eu: null, phone_code: '', source: '' },
      selectedCity: { id: '', name: '', part_of_eu: null, phone_code: '', source: '' },
      countryId: '',
      degreeField: '',
      address: '',
      postal: '',
      individiuals: 1,
      fullTime: true,
      duration: 1,
      workplace: 2,
      selectedLanguageForAi: 'en',

      vat: null,
      regNumber: null,
      invoiceEmail: null,
    },
    competencesOptions: [],
    languagesOptions: [],
    isNextDisabled: true,
    isCopied: false,
    isGeneratedOnce: false,
  }),
  validations: {
    selectedFields: {
      selectedJobTitle: {
        required,
        minLength: minLength(3),
      },
      selectedCountry: {
        required,
      },
      selectedEmploymentType: {
        required,
      },
      selectedExperience: {
        required,
      },
      selectedRelocation: {
        required,
      },
    },
  },
  methods: {
    ...mapActions([
      'retrieveJobsForEmployerDropdown',
      'retrieveCitiesListByCountryId',
      'retrieveCompetencesList',
      'copyExistingJobAd',
      'retrieveJobAdById',
      'AddJobAd',
      /* 'retrieveLanguagesList', */
      /* 'retrieveAllCountries', */
    ]),
    ...mapActions('managerStoreModule', [
      'ManagerAddJob',
      'retrieveManagerUserProfile',
      'retrieveManagerJobsDropdown',
      'retrieveManagerJobAdByIdForCopyExisting',
      'retrieveManagerJobById',
    ]),
    stepValidator() {
      // STEP 1
      if (this.step === 1) {
        if (
          this.$v.selectedFields.selectedJobTitle.$invalid === true ||
          this.$v.selectedFields.selectedEmploymentType.$invalid === true ||
          this.$v.selectedFields.cityId ||
          this.$v.selectedFields.countryId
        ) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }
      }
      //STEP 2
      if (this.step === 2) {
        if (this.$v.selectedFields.selectedExperience.$invalid === true) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }
      }
    },
    getLanguageByIso(lang) {
      const languages = {
        ar: 'Arabic',
        bg: 'Bulgarian',
        zh_Hans: 'Chinese (Simplified)',
        zh_Hant: 'Chinese (Traditional)',
        cs: 'Czech',
        da: 'Danish',
        nl: 'Dutch',
        en: 'English',
        fi: 'Finnish',
        fr: 'French',
        de: 'German',
        el: 'Greek',
        he: 'Hebrew',
        hu: 'Hungarian',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        no: 'Norwegian',
        pl: 'Polish',
        pt: 'Portuguese',
        ro: 'Romanian',
        ru: 'Russian',
        es: 'Spanish',
        sv: 'Swedish',
        tr: 'Turkish',
        uk: 'Ukrainian',
      };

      return languages[lang] || 'Unknown Language';
    },

    handleEmployerJobs() {
      this.isLoading = false;
    },
    copyExistingJob() {
      this.retrieveManagerJobAdByIdForCopyExisting({ jobID: this.selectedJobModel.id })
        .then(({ data }) => {
          this.selectedFields.selectedJobTitle = data.title;
          this.selectedFields.address = data.address.address;
          this.selectedFields.postal = data.address.postal_code;

          this.selectedFields.selectedCountry = {
            id: data.country.id,
            name: data.country.name,
            part_of_eu: null,
            phone_code: '',
            source: '',
          };

          this.selectedFields.selectedCity = {
            id: data.city.id,
            name: data.city.name,
            part_of_eu: null,
            phone_code: '',
            source: '',
          };

          /* New Fields */
          this.selectedFields.duration = data.duration;
          this.selectedFields.individiuals = data.individuals_number;
          this.selectedFields.fullTime = data.full_time;
          this.selectedFields.workplace = data.workplace;

          this.selectedFields.selectedEmploymentType = data.employment_type;
          this.selectedFields.selectedExperience = data.years_experience;
          if (data.degree_type === '' || data.degree_type === null) {
            this.selectedFields.selectedDegree = '';
          } else {
            this.selectedFields.selectedDegree = data.degree_type
              ? data.degree_type.toString()
              : data.degree_type;
          }

          this.selectedFields.degreeField = data.degree_field;

          this.selectedFields.competences = [...data.required_competences];
          this.selectedFields.advantageCompetences = [...data.advantage_competences];
          this.selectedFields.languages = [...data.languages];
          this.selectedFields.selectedRelocation = data.relocation;

          //this.selectedFields.description = data.description;

          this.selectedFields.aboutUs = data.about_us
            ? this.removeHtmlTags(data.about_us, 'b', 'u', 'p', 'br')
            : '';

          this.selectedFields.benefits = data.benefits
            ? data.benefits
            : this.selectedFields.benefits;

          this.generateCopyExistingJobAd(data.description);
        })
        .then(() => {
          this.closeModal();
        })
        .catch(err => {
          //   this.isCopied = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });

      if (this.selectedFields.selectedEmploymentType) {
        this.isNextDisabled = false;
      }
    },
    generateCopyExistingJobAd(description) {
      this.isCopied = true;
      this.jobAdText = this.removeHtmlTags(description, 'div');
    },
    closeModal() {
      this.showModal = false;
      this.selectedJobModel = null;
    },
    oncompetenceSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.competencesOptions = this.getCompetencesFilterList;
      }

      loading(false);
    },
    /*  onLanguageSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.languagesOptions = this.getLanguagesList;
      }

      loading(false);
    }, */
    fetchCitiesByCountryId() {
      this.retrieveCitiesListByCountryId({ id: this.selectedFields.selectedCountry.id });
      this.selectedFields.selectedCity = '';
    },

    checkDegree() {
      if (this.selectedFields.selectedDegree === '') {
        this.selectedFields.degreeField = '';
      }
    },
    forceRerender() {
      this.componentKey++;
      this.isReadonly = false;
    },
    saveAd() {
      this.isLoading = true;
      let js_employer_id;
      if (this.$route.name == 'employer_id') {
        js_employer_id = this.$route.params.employer_id;
      } else {
        js_employer_id = this.selectedFields.selectedEmployer.id;
      }

      this.AddJobAd({
        js_employer_id: js_employer_id,
        title: this.selectedFields.selectedJobTitle,
        description: this.jobAdText,
        country_id: this.selectedFields.selectedCountry.id,
        city_id: this.selectedFields.selectedCity.id,
        street: this.selectedFields.address,
        postal_code: this.selectedFields.postal,
        employment_type: this.selectedFields.selectedEmploymentType,
        years_experience: this.selectedFields.selectedExperience,
        degree: this.selectedFields.selectedDegree,
        degree_field: this.selectedFields.degreeField,
        workplace: Number(this.selectedFields.workplace),
        competences: this.selectedFields.competences.map(c =>
          c.hasOwnProperty('competence_id') ? c.competence_id : c.id,
        ),
        advantage_competences: this.selectedFields.advantageCompetences.map(advantageCompetence =>
          advantageCompetence.hasOwnProperty('competence_id')
            ? advantageCompetence.competence_id
            : advantageCompetence.id,
        ),
        languages: this.selectedFields.languages.map(l =>
          l.hasOwnProperty('language_id') ? l.language_id : l.id,
        ),
        relocation: this.selectedFields.selectedRelocation,
        /* advertizing_start_date: this.startDate,
        advertizing_end_date: this.endDate, */
        comments: this.selectedFields.comments,
        status: 0,
      })
        .then(response => {
          this.isLoading = false;

          this.$toasted.success(`You successfully posted a job`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });

          this.$router.push({
            name: 'manager_job_uuid',
            params: { manager_job_uuid: response.id },
          });

          location.reload();

          this.jobAdText = '';
          this.isGeneratedOnce = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    saveAndPublishAd(status) {
      this.isLoading = true;

      if (this.selectedFields.individiuals === 0) {
        this.$toasted.error('Number of individuals must be at least 1', {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 8000,
        });
        this.isLoading = false;
        return false;
      }

      this.ManagerAddJob({
        title: this.selectedFields.selectedJobTitle,
        description: this.jobAdText,
        note: this.selectedFields.comments,
        country_id: this.selectedFields.selectedCountry.id,
        city_id: this.selectedFields.selectedCity.id,
        street: this.selectedFields.address,
        postal_code: this.selectedFields.postal,
        employment_type: this.selectedFields.selectedEmploymentType,
        years_experience: this.selectedFields.selectedExperience,
        degree_type: this.selectedFields.selectedDegree,
        degree_field: this.selectedFields.degreeField,
        individuals_number: this.selectedFields.individiuals,
        full_time: this.selectedFields.fullTime,
        duration: this.selectedFields.duration,
        service_level: Number(this.selectedPlan),
        summary: this.selectedFields.comments,
        workplace: Number(this.selectedFields.workplace),

        competences: this.selectedFields.competences.map(c =>
          c.hasOwnProperty('competence_id') ? c.competence_id : c.id,
        ),
        advantage_competences: this.selectedFields.advantageCompetences.map(advantageCompetence =>
          advantageCompetence.hasOwnProperty('competence_id')
            ? advantageCompetence.competence_id
            : advantageCompetence.id,
        ),
        languages: this.selectedFields.languages.map(l =>
          l.hasOwnProperty('language_id') ? l.language_id : l.id,
        ),
        relocation: this.selectedFields.selectedRelocation,
        comments: this.selectedFields.comments,
        status: status,
        eu_vat_number: this.selectedFields.vat,
        invoice_email: this.selectedFields.invoiceEmail,
        registration_number: this.selectedFields.regNumber,
      })
        .then(response => {
          this.isLoading = false;

          this.$toasted.success(`You successfully posted a job`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });

          this.$router.push({
            name: 'manager_job_uuid',
            params: { manager_job_uuid: response.data.id },
          });

          //  location.reload();

          /*  this.jobAdText = '';
          this.isGeneratedOnce = false; */
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    submitTemplate() {
      this.isLoading = true;
      this.save();
      this.getCETDate();
      const formData = new FormData();

      let htmlContent = this.generateString();
      let requestData = JSON.stringify({
        htmlContent: htmlContent,
      });
      formData.append('html', requestData);
      formData.append('signature', this.signature);
      formData.append('signing_date', this.currentDate);
      formData.append('type', this.selectedPlan);

      axios
        .post(`${process.env.VUE_APP_API_URL}/manager/agreements/create`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            Accept: 'application/json',
          },
        })
        .then(() => {
          this.saveAndPublishAd(1);
        })
        .catch(err => {
          this.isLoading = false;
        });
    },

    nextFirst() {
      if (this.selectedPlan === 0) {
        this.step++;
      } else {
        this.step = 0.5;
      }
      this.$emit('step', { step: this.step, plan: this.selectedPlan });
    },

    next() {
      this.step++;
      if (this.step === 3) {
        this.isNextDisabled = false;

        if (!this.isGeneratedOnce && !this.isCopied) {
          this.generateAd();
          this.isGeneratedOnce = true;
        }

        this.forceRerender();
      }
      if (
        this.step === 5 &&
        this.getManagerUserProfile.employer_registration_number !== null &&
        this.getManagerUserProfile.employer_eu_vat_number !== null &&
        this.getManagerUserProfile.employer_invoice_email !== null
      ) {
        this.step++;
      }
      if (this.step === 6) {
        this.openContract();
      }
      this.$emit('step', { step: this.step, plan: this.selectedPlan });
    },

    newNext() {
      this.step = 1;
      this.$emit('step', { step: this.step, plan: this.selectedPlan });
    },

    newPrev() {
      this.step = 0;
      this.$emit('step', { step: this.step, plan: this.selectedPlan });
    },

    prev() {
      if (this.selectedPlan !== 0 && this.step === 1) {
        this.step = 0.5;
        this.$emit('step', { step: this.step, plan: this.selectedPlan });
      } else {
        this.step--;
      }
      if (
        this.step === 5 &&
        this.getManagerUserProfile.employer_registration_number !== null &&
        this.getManagerUserProfile.employer_eu_vat_number !== null &&
        this.getManagerUserProfile.employer_invoice_email !== null
      ) {
        this.step--;
      }
    },

    competencesList(competencesList) {
      const list = competencesList.map(c => c.name).join(', ');

      let final = '';

      if (list.lastIndexOf(',') !== -1) {
        final = `${list.slice(0, list.lastIndexOf(','))} and${list.slice(
          list.lastIndexOf(',') + 1,
        )}`;
      } else {
        final = list;
      }

      return final;
    },
    removeMoreHtmlTags(adText, ...args) {
      const regex = /<(\/?)(\w+)[^>]*\/?>/g;
      if (adText) {
        return adText
          .replace(regex, (_, endMark, tag) => {
            return args.includes(tag) ? '<' + endMark + tag + '>' : '';
          })
          .replace(/\r?\n/g, '')
          .replace(/<!--.*?-->/g, '');
      } else {
        return '';
      }
    },
    removeHtmlTags(adText, ...args) {
      // const regex = /(<([^>]+)>)/gi;
      const removeAllDivTags = /<[/]{0,1}(div)[^><]*>/g;

      return adText
        .replace(removeAllDivTags, '')
        .replace(/<!--.*?-->/g, '')
        .replace(/\r?\n/g, '');
    },
    addLiNodes() {
      const nodesList = [];

      const getDegreeNode = (degreeCode, field) => {
        switch (Number(degreeCode)) {
          case 1:
            return `University level studies`;
          case 2:
            return `Bachelor's degree in ${field} or similar`;
          case 3:
            return `Master's degree in ${field} or similar`;
          case 4:
            return `PhD in ${field} or similar`;
          default:
            return '';
        }
      };

      // [Years of experience]+ years of relevant working experience
      if (this.selectedFields.selectedExperience) {
        nodesList.push(
          `<li>${this.selectedFields.selectedExperience} years of relevant working experience</li>`,
        );
      }

      // Solid experience in [Skill1], [Skill2], … and [SkillN]
      if (this.selectedFields.competences.length) {
        nodesList.push(
          `<li>Solid experience in ${this.competencesList(this.selectedFields.competences)}</li>`,
        );
      }

      // If degree is selected then one of these: University level studies, Bachelor’s degree in [degree field] or similar, Master’s degree in [degree field] or similar, PhD in [degree field] or similar
      if (this.selectedFields.selectedDegree) {
        nodesList.push(
          `<li>${getDegreeNode(
            this.selectedFields.selectedDegree,
            this.selectedFields.degreeField,
          )}</li>`,
        );
      }

      // Good [Language1], [Language2], … and [LanguageN] skills verbally and in writing
      if (this.selectedFields.languages.length) {
        nodesList.push(
          `<li>Good ${this.competencesList(
            this.selectedFields.languages,
          )} skills verbally and in writing</li>`,
        );
      }

      return nodesList;
    },

    generateAd() {
      const nodes = this.addLiNodes();

      let employerName = '';
      let employerAboutUs = '';

      if (this.$route.path === '/manager/user/jobs') {
        employerName = this.getManagerUserProfile.employer_name;
        employerAboutUs = this.getManagerUserProfile.employer_description;
      } else {
        employerName = this.getManagerUserProfile.employer_name;
        employerAboutUs = this.getManagerUserProfile.employer_description;
      }

      /*
      const employerName = this.removeMoreHtmlTags(this.getManagerProfile.employer_name, '<p>');
      const employerAboutUs = this.removeMoreHtmlTags(
        this.getManagerProfile.description,
        '<p>',
        '<div>',
      ); */

      const previousExperience = this.selectedFields.advantageCompetences.length
        ? `<li>Have previous experience in ${this.competencesList(
            this.selectedFields.advantageCompetences,
          )}</li>`
        : '';

      const advantageSection = previousExperience
        ? `<br /><b>It's an advantage if you:</b><ul>${previousExperience}</ul>`
        : '';

      const benefitsSection = this.selectedFields.benefits
        ? `<br /><b>Benefits:</b>${this.selectedFields.benefits}`
        : '<br /><b>Benefits:</b>';

      this.jobAdText = `<p>(Introduction text)</p><br /><p><b>We believe that you have the following qualifications:</b></p><ul>${
        nodes.length ? nodes.join('') : ''
      }</ul>${advantageSection}${benefitsSection}<p></br></p><p>If you find our proposal interesting and you meet the above requirements for the position, please don't hesitate to apply.</p><br /><p>All applications will be treated strictly confidential.</p><br /><p><i>About ${employerName}: </i></p>${employerAboutUs}`;

      this.forceRerender();
    },
    reGenerateAd() {
      const nodes = this.addLiNodes();

      let employerName = '';
      let employerAboutUs = '';

      if (this.$route.path === '/manager/user/jobs') {
        employerName = this.getManagerUserProfile.employer_name;
        employerAboutUs = this.getManagerUserProfile.employer_description;
      } else {
        employerName = this.getManagerUserProfile.employer_name;
        employerAboutUs = this.getManagerProfile.description;
      }

      const previousExperience = this.selectedFields.advantageCompetences.length
        ? `<li>Have previous experience in ${this.competencesList(
            this.selectedFields.advantageCompetences,
          )}</li>`
        : '';

      const advantageSection = previousExperience
        ? `<br /><b>It's an advantage if you:</b><ul>${previousExperience}</ul>`
        : '';

      const employerBenefits = this.getEmployerById && this.getEmployerById.benefits;

      const benefitsSection =
        this.selectedFields.benefits || employerBenefits
          ? `<br /><b>Benefits:</b>${this.selectedFields.benefits || employerBenefits}`
          : '<br /><b>Benefits:</b>';

      this.jobAdText = `<p>(Introduction text)</p><br /><p><b>We believe that you have the following qualifications:</b></p><ul>${
        nodes.length ? nodes.join('') : ''
      }</ul>${advantageSection}${benefitsSection}<p></br></p><p>If you find our proposal interesting and you meet the above requirements for the position, please don't hesitate to apply.</p><br /><p>All applications will be treated strictly confidential.</p><br /><p><i>About ${employerName}: </i></p>${employerAboutUs}`;

      this.forceRerender();
    },

    getDegreeField(val) {
      if (val === 1) {
        return 'University';
      } else if (val === 2) {
        return "Bachelor's degree";
      } else if (val === 3) {
        return "Master's degree";
      } else if (val === 4) {
        return 'PhD';
      } else {
        return '';
      }
    },

    generateWithAi() {
      this.isGeneratingAI = true;
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/chatgpt/ask`,
          {
            title: this.selectedFields.selectedJobTitle,
            years_experience: Number(this.selectedFields.selectedExperience),
            degree: this.getDegreeField(this.selectedFields.selectedDegree),
            degree_field: this.selectedFields.degreeField,
            competences: this.selectedFields.competences.map(c =>
              c.hasOwnProperty('competence_id') ? c.competence_id : c.id,
            ),
            competence_advantage: this.selectedFields.advantageCompetences.map(
              advantageCompetence =>
                advantageCompetence.hasOwnProperty('competence_id')
                  ? advantageCompetence.competence_id
                  : advantageCompetence.id,
            ),
            language_skills: this.selectedFields.languages.map(l =>
              l.hasOwnProperty('language_id') ? l.language_id : l.id,
            ),
            draft_description: this.jobAdText,
            language: this.getLanguageByIso(this.selectedFields.selectedLanguageForAi),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.jobAdText = res.data.reply;
          this.isGeneratingAI = false;
        })
        .catch(() => {
          this.isGeneratingAI = false;
        });
    },

    translateWithAi() {
      this.isGeneratingAI = true;
      this.reGenerateAd();
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/chatgpt/translate`,
          {
            text: this.jobAdText,
            language: this.getLanguageByIso(this.selectedFields.selectedLanguageForAi),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.jobAdText = res.data[0].replace(/\n/g, '');
          this.isGeneratingAI = false;
        })
        .catch(() => {
          this.isGeneratingAI = false;
        });
    },

    checkValues() {
      const {
        employer_basic,
        employer_sourcing,
        employer_full_service,
      } = this.getManagerUserProfile;
      const values = [employer_basic, employer_sourcing, employer_full_service];
      const count = values.filter(value => value > 1).length;
      if (count === 1) {
        const selectedIndex = values.findIndex(value => value > 1);
        this.selectedPlan = selectedIndex;
        this.canChoose = false;
        this.step = 1;
        this.$emit('step', this.step);
      } else {
        this.filterPlans();
        this.canChoose = true;
        this.step = 0;
        this.$emit('step', this.step);
      }
    },

    filterPlans() {
      const {
        employer_basic,
        employer_sourcing,
        employer_full_service,
      } = this.getManagerUserProfile;
      const allPlans = {
        employer_basic,
        employer_sourcing,
        employer_full_service,
      };

      const filteredPlans = Object.entries(allPlans)
        .filter(([, value]) => value !== 1)
        .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});

      const planKeys = Object.keys(filteredPlans);

      if (planKeys.includes('employer_full_service')) {
        this.selectedPlan = 2;
      } else if (planKeys.includes('employer_sourcing')) {
        this.selectedPlan = 1;
      } else if (planKeys.includes('employer_basic')) {
        this.selectedPlan = 0;
      }
    },

    formatPrice(value) {
      const str = String(value).replace(',', '.');
      let num = parseFloat(str);
      if (isNaN(num)) return '';
      num = Math.round(num);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    setPlansOnLoad() {
      this.sourcingPlan = this.getManagerUserProfile.online_agreements_data.find(
        item => item.type === 1,
      );
      this.fullServicePlan = this.getManagerUserProfile.online_agreements_data.find(
        item => item.type === 2,
      );
      this.isLoading = false;
    },

    openContract() {
      this.$nextTick(() => {
        this.getCETDateHours();
        const canvas = this.$refs.signaturePad;
        if (canvas) {
          this.signaturePad = new SignaturePad(canvas, {
            penColor: 'rgb(66, 133, 244)',
          });
          this.resizeCanvas();
          window.addEventListener('resize', this.resizeCanvas);
        }
      });
    },

    resizeCanvas() {
      const canvas = this.$refs.signaturePad;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      this.signaturePad.clear();
    },
    clear() {
      this.signaturePad.clear();
    },

    getCETDate() {
      const date = new Date();
      const options = {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      const formatter = new Intl.DateTimeFormat('en-GB', options);
      const parts = formatter.formatToParts(date);
      const year = parts.find(part => part.type === 'year').value;
      const month = parts.find(part => part.type === 'month').value;
      const day = parts.find(part => part.type === 'day').value;

      this.currentDate = `${year}-${month}-${day}`;
    },

    getCETDateHours() {
      const date = new Date();
      const options = {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      const formatter = new Intl.DateTimeFormat('en-GB', options);
      const parts = formatter.formatToParts(date);
      const year = parts.find(part => part.type === 'year').value;
      const month = parts.find(part => part.type === 'month').value;
      const day = parts.find(part => part.type === 'day').value;
      const hour = parts.find(part => part.type === 'hour').value;
      const minute = parts.find(part => part.type === 'minute').value;
      const second = parts.find(part => part.type === 'second').value;

      this.currentDateHours = `${year}-${month}-${day}-${hour}:${minute}`;
    },

    save() {
      if (this.signaturePad.isEmpty()) {
        alert('Please provide a signature first.');
      } else {
        this.signature = this.signaturePad.toDataURL();
      }
    },

    previewRecruitingContract() {
      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>Agreement for Recruiting Services</title>
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
      .freelancing-container {
        font-family: "Lato", sans-serif;
        padding-left: 20px;
        padding-right: 20px;
      }
      .freelancing-container p {
        font-size: 14px;
      }
      .freelancing-container h2 {
        font-size: 18px;
        font-weight: 800;
      }
      .freelancing-container h3 {
        font-weight: 800;
        font-size: 13px;
        margin-bottom: 20px;
        margin-top: 20px;
      }
      .freelancing-container .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .freelancing-container .flex img {
        width: 50%;
        height: auto;
      }
    </style>
</head>
<body>
  <div class="freelancing-container">
    <img
      style="max-width:200px; margin-bottom:60px; margin-left:-50px; margin-top:30px"
      src="https://jobshark.eu/img/comstream-logo.af65b641.png"
      alt="Comstream logo"
    />

    <h2 style="margin-bottom: 30px;">Agreement for Recruiting Services</h2>

    <p style="margin-bottom: 25px;">
      This is an agreement between Comstream AB, a Swedish entity with registration number
      556945-8911, hereinafter referred to as “Comstream” and ${this.getManagerUserProfile.employer_name}, an entity
      based in ${this.getManagerUserProfile.employer_country.name} with registration number ${this.selectedFields.regNumber}, hereinafter referred
      to as “the Customer” regarding recruiting services, hereinafter “the Service”.
    </p>

    <h3>1. General Conditions</h3>
    <p>1.1. The Customer hereby appoints Comstream to find, qualify and present suitable
    individuals, hereinafter ”Candidates”, for a certain job position, hereinafter ”the
    Position”. The Customer enjoys the opportunity to employ a Candidate according to
    the conditions in this agreement.</p>

    <p>1.2. Comstream shall present CV and other relevant received information regarding a
    Candidate to the Customer. The Customer may not disclose information about the
    Candidate to third parties without Comstream’s prior approval.</p>

    <p>1.3. On request by the Customer, Comstream shall provide possibility to interview the
    Candidate personally or by video meeting, phone or other similar way. In the occurrence
    of any travelling expenses related to such meetings, the Customer shall bear these costs.</p>

    <h3>2. Responsibilities of the Parties</h3>
    <p>2.1. Comstream shall use its best efforts to find suitable Candidates for the Customer for
    each Position.</p>

    <p>2.2. It is the responsibility of the Customer to provide Comstream with an adequate
    description of the Position and other relevant information about the Position.</p>

    <p>2.3. The Customer shall, at his/her own discretion, decide whether a Candidate shall be
    employed.</p>

    <p>2.4. The Customer shall notify Comstream within fourteen (14) days from the time an
    agreement about employment has been reached with a Candidate. If the Customer
    neglects to report an employment within this period, Comstream has the right to a
    penalty, in addition to the other fees mentioned in this agreement, of 1.000 EUR per
    started month but maximum 12.000 EUR per employment.</p>

    <h3>3. Fees and Payment Terms</h3>
    <p>3.1. The Customer shall pay a starting fee to Comstream for each Position. The starting
    fee shall be paid within twenty (20) days from the invoicing date.</p>

    <p>3.2. If the Customer, directly or indirectly, employs or in any other way contracts a
    Candidate, the Customer shall pay a recruiting fee to Comstream. The fee is due upon
    agreement of employment. Payment terms are twenty (20) days from the invoicing
    date.</p>

    <p>3.3. In case of delay of payment of amounts due, the Customer shall be obliged to pay
    penalty interest amounting to 12% per year. All mentioned fees are exclusive of VAT.</p>

    <h3>4. Termination</h3>
    <p>4.1. Each Party may, at any time, terminate this Contract by one (1) month’s written
    notice.</p>

    <p>4.2. Comstream’s right to compensation according to 3.2 is valid during the effective
    time of the agreement and one (1) year thereafter.</p>

    <h3>5. Secrecy</h3>
    <p>5.1. Any information received by one party shall be treated as strictly confidential by the
    other party and the receiving party shall not communicate the information in any form
    to any third party.</p>

    <p>5.2. The Customer may not use or forward job ads, advertising materials or descriptions
    of the competence profile that Comstream produces for a Position.</p>

    <h3>6. Processing of Personal Data</h3>
    <p>6.1. Comstream and the Customer are jointly considered to be Processors of personal
    data according to GDPR. Both parties commit on adhering to GDPR and other relevant
    legislation as for the handling of personal data.</p>

    <p>6.2. A Candidate’s personal data will be processed after acceptance of Comstream’s
    Integrity Policy.</p>

    <h3>7. Limitation of Liability</h3>
    <p>7.1. Comstream should not, in any way, be considered as the employer for the
    Candidate.</p>

    <p>7.2. Comstream is not responsible for any indirect damages of any kind and the liability
    is in all cases limited to the amount that the Customer has paid for the Service.</p>

    <h3>8. Applicable Laws</h3>
    <p>8.1. This Contract shall be governed by the laws of Sweden and any dispute shall be settled
    by a general Swedish court of law.</p>
  </div>
</body>
</html>`;
    },

    generateString() {
      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>Agreement for Recruiting Services</title>
     <style>
    @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
        .freelancing-container {
           font-family: "Lato", sans-serif;
           padding-left:40px;
           padding-right:40px;
        }
        .freelancing-container p {
          font-size: 14px
        }
        .freelancing-container  h2 {
          font-size:18px;
          font-weight:800;
        }
        .freelancing-container  h3 {
          font-weight:800;
          font-size:13px;
          margin-bottom:20px;
          margin-top:20px;
        }

        .freelancing-container .flex {
          display:flex;
          justify-content: space-between;
          align-items: center;
        }

        .freelancing-container .flex img {
        width:50%;
        height:auto;
        }
    </style>
</head>
<body>
  <div class="freelancing-container">
    <img style="max-width:200px; margin-bottom:60px; margin-left:-52px; margin-top:30px" src="https://jobshark.eu/img/comstream-logo.af65b641.png" alt="Comstream logo" />
    <h2 style="margin-bottom: 30px;">Agreement for Recruiting Services</h2>

    <p style="margin-bottom: 25px;">
      This is an agreement between Comstream AB, a Swedish entity with registration number
      556945-8911, hereinafter referred to as “Comstream” and ${this.getManagerUserProfile.employer_name}, an entity
      based in ${this.getManagerUserProfile.employer_country.name} with registration number ${this.selectedFields.regNumber}, hereinafter referred
      to as “the Customer” regarding recruiting services, hereinafter “the Service”.
    </p>

    <h3>1. General Conditions</h3>
    <p>1.1. The Customer hereby appoints Comstream to find, qualify and present suitable
    individuals, hereinafter ”Candidates”, for a certain job position, hereinafter ”the
    Position”. The Customer enjoys the opportunity to employ a Candidate according to
    the conditions in this agreement.</p>

    <p>1.2. Comstream shall present CV and other relevant received information regarding a
    Candidate to the Customer. The Customer may not disclose information about the
    Candidate to third parties without Comstream’s prior approval.</p>

    <p>1.3. On request by the Customer, Comstream shall provide possibility to interview the
    Candidate personally or by video meeting, phone or other similar way. In the occurrence
    of any travelling expenses related to such meetings, the Customer shall bear these costs.</p>

    <h3>2. Responsibilities of the Parties</h3>
    <p>2.1. Comstream shall use its best efforts to find suitable Candidates for the Customer for
    each Position.</p>

    <p>2.2. It is the responsibility of the Customer to provide Comstream with an adequate
    description of the Position and other relevant information about the Position.</p>

    <p>2.3. The Customer shall, at his/her own discretion, decide whether a Candidate shall be
    employed.</p>

    <p>2.4. The Customer shall notify Comstream within fourteen (14) days from the time an
    agreement about employment has been reached with a Candidate. If the Customer
    neglects to report an employment within this period, Comstream has the right to a
    penalty, in addition to the other fees mentioned in this agreement, of 1.000 EUR per
    started month but maximum 12.000 EUR per employment.</p>

    <h3>3. Fees and Payment Terms</h3>
    <p>3.1. The Customer shall pay a starting fee to Comstream for each Position. The starting
    fee shall be paid within twenty (20) days from the invoicing date.</p>

    <p>3.2. If the Customer, directly or indirectly, employs or in any other way contracts a
    Candidate, the Customer shall pay a recruiting fee to Comstream. The fee is due upon
    agreement of employment. Payment terms are twenty (20) days from the invoicing
    date.</p>

    <p>3.3. In case of delay of payment of amounts due, the Customer shall be obliged to pay
    penalty interest amounting to 12% per year. All mentioned fees are exclusive of VAT.</p>

    <h3>4. Termination</h3>
    <p>4.1. Each Party may, at any time, terminate this Contract by one (1) month’s written
    notice.</p>

    <p>4.2. Comstream’s right to compensation according to 3.2 is valid during the effective
    time of the agreement and one (1) year thereafter.</p>

    <h3>5. Secrecy</h3>
    <p>5.1. Any information received by one party shall be treated as strictly confidential by the
    other party and the receiving party shall not communicate the information in any form
    to any third party.</p>

    <p>5.2. The Customer may not use or forward job ads, advertising materials or descriptions
    of the competence profile that Comstream produces for a Position.</p>

    <h3>6. Processing of Personal Data</h3>
    <p>6.1. Comstream and the Customer are jointly considered to be Processors of personal
    data according to GDPR. Both parties commit on adhering to GDPR and other relevant
    legislation as for the handling of personal data.</p>

    <p>6.2. A Candidate’s personal data will be processed after acceptance of Comstream’s
    Integrity Policy.</p>

    <h3>7. Limitation of Liability</h3>
    <p>7.1. Comstream should not, in any way, be considered as the employer for the
    Candidate.</p>

    <p>7.2. Comstream is not responsible for any indirect damages of any kind and the liability
    is in all cases limited to the amount that the Customer has paid for the Service.</p>

    <h3>8. Applicable Laws</h3>
    <p>8.1. This Contract shall be governed by the laws of Sweden and any dispute shall be settled
    by a general Swedish court of law.</p>

 <div>
          <p style="margin-bottom:0px;" class="section-title">
              ${this.getManagerUserProfile.employer_city.name}, ${this.getManagerUserProfile.employer_country.name} on ${this.currentDate}
              </p>
              <p style="margin-bottom:0px;" class="section-title">
              ${this.getManagerUserProfile.employer_name}
              </p>
               <img style="width: 240px; height: 75px; object-fit: contain;" src="${this.signature}"/>
               <p style="margin-top:-6px;">
              ${this.getManagerUserProfile.first_name} ${this.getManagerUserProfile.last_name}
              </p>
              <div style="margin-top:-5px;">
              <span style="font-size:12px; margin-top:-12px;">This agreement was digitally signed on CET ${this.currentDateHours} by ${this.getManagerUserProfile.email}.</span>
              </div>
  </div>
</body>
</html>`;
    },
  },
  computed: {
    ...mapGetters([
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getAllCountries',
      'getLanguagesList',
    ]),
    ...mapGetters('managerStoreModule', [
      'getManagerProfile',
      'getManagerUserProfile',
      'getManagerJobsDropdown',
      'getManagerJobByID',
    ]),
  },
  watch: {
    'selectedFields.selectedCountry': function(newSelectedCountry) {
      localStorage.managerAddJobModalDataSelectedCountry = JSON.stringify(newSelectedCountry);
    },
    'selectedFields.selectedCity': function(newSelectedCity) {
      localStorage.managerAddJobModalDataSelectedCity = JSON.stringify(newSelectedCity);
    },
  },
  created() {
    /*     if (localStorage.managerAddJobModalDataSelectedCountry) {
      const selectedCountry = JSON.parse(localStorage.managerAddJobModalDataSelectedCountry);
      this.selectedFields.selectedCountry = selectedCountry;
    }

    if (localStorage.managerAddJobModalDataSelectedCity) {
      const selectedCity = JSON.parse(localStorage.managerAddJobModalDataSelectedCity);
      this.selectedFields.selectedCity = selectedCity;
    } */
  },
  mounted() {
    this.isLoading = true;
    this.retrieveManagerJobsDropdown();
    this.retrieveManagerUserProfile().then(() => {
      this.setPlansOnLoad();
    });

    if (this.$route.path === '/manager/user/jobs') {
      this.selectedFields.address = this.getManagerUserProfile.employer_address.address;
      this.selectedFields.postal = this.getManagerUserProfile.employer_address.postal_code;
      this.selectedFields.selectedCountry = this.userProfile.employer_country;
      this.selectedFields.selectedCity = this.userProfile.employer_city;
      this.selectedFields.benefits = this.getManagerUserProfile.employer_benefits;
      this.selectedFields.description = this.getManagerUserProfile.employer_description;
    } else {
      this.selectedFields.address = this.getManagerUserProfile.employer_address.address;
      this.selectedFields.postal = this.getManagerUserProfile.employer_address.postal_code;
      this.selectedFields.selectedCountry = this.userProfile.employer_country;
      this.selectedFields.selectedCity = this.userProfile.employer_city;
      this.selectedFields.benefits = this.getManagerUserProfile.employer_benefits;
      this.selectedFields.description = this.getManagerUserProfile.employer_description;
    }

    this.retrieveCitiesListByCountryId({ id: this.selectedFields.selectedCountry.id });
    // if (localStorage.addJobCountry) this.selectedFields.selectedCountry = localStorage.addJobCountry;

    this.retrieveCompetencesList();
    this.forceRerender();
    this.checkValues();

    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl);
    });
    var popover = new bootstrap.Popover(document.querySelector('.table-section'), {
      container: 'body',
    });
    this.selectedFields.vat = this.getManagerUserProfile.employer_eu_vat_number;
    if (this.getManagerUserProfile.employer_invoice_email !== null) {
      this.selectedFields.invoiceEmail = this.getManagerUserProfile.employer_invoice_email;
    } else {
      this.selectedFields.invoiceEmail = this.getManagerUserProfile.employer_email;
    }
    this.selectedFields.regNumber = this.getManagerUserProfile.employer_registration_number;
  },
};
</script>

<style lang="scss" scoped>
.contract {
  max-height: 500px;
  padding-left: 8%;
  padding-right: 8%;
  padding-bottom: 30px;
  overflow-y: auto;
}
.price-list {
  li {
    margin-bottom: 12px;
    padding-bottom: 5px;
    strong {
      display: inline-block;
      min-width: 180px;
    }
  }
}
.sign {
  justify-content: space-between;
  align-items: center;
  padding-left: 8%;
  padding-right: 8%;
}

.signature-pad {
  background: #fcf3b6;
  width: 100%;
  height: 170px;
}
.modal-mask {
  z-index: 1000 !important;
}

.plan {
  height: 90px;
}

.form-check-input:checked {
  background-color: #000;
  border-color: #000;
}
.textarea-hidden {
  height: 150px;
}

.form-group.required-fixed-right- {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.editor {
  box-shadow: 0px 2px 3px #0000000d;
  /* border: 1px solid #d7dae2; */
  border-radius: 4px;
  opacity: 1;
}

.social-buttons a {
  font-size: 0.875rem;
  font-weight: 400;
  box-shadow: 0px 1px 2px #00000029;
  border-radius: 4px;
}

.separator {
  position: relative;
  text-align: center;
  color: #b6b6b6;
  opacity: 0.8;

  span {
    display: inline-block;
    vertical-align: baseline;
    position: relative;
    padding: 0 20px;

    &:before,
    &:after {
      content: '';
      display: block;
      width: 5.5rem;
      position: absolute;
      top: 0.73em;
      border-top: 1px solid #b6b6b6;
    }

    &:before {
      right: 100%;
    }

    &:after {
      left: 100%;
    }
  }
}

.table-section {
  .spanner {
    position: absolute;
    right: 12px;
    top: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    padding: 0;
    background: #f05b01;
    font-size: 13px;
    width: 21px;
    height: 21px;
    border-radius: 100%;
    font-weight: 600;
    text-decoration: none;
  }
  p {
    font-size: 14px;
    span {
      font-weight: 700;
    }
  }
  .table-bordered {
    /*     td {
      border: 3px solid #fff;
    } */
  }
  table {
    thead {
      tr {
        th {
          color: #fff;
          background: #f05b01;
          text-align: center;
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 500;
          position: relative;
        }
        td {
          text-align: center;
        }
        &:nth-child(odd) {
          background: rgba(255, 217, 196, 255);
        }
        &:nth-child(even) {
          background: #ffbe94;
        }
        &:last-of-type {
          color: #fff;
          th {
            font-weight: 600;
          }
          background: #f05b01 !important;
          font-weight: 600;
        }
      }
    }
  }
}
/* MODAL */

/* Multi Step Form CSS */
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}
.form-group.required-fixed-right {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 9px;
    color: red;
    opacity: 0.6;
  }
}
.form-group.required-fixed-city {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.required-fixed-country {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 7px;
    color: red;
    opacity: 0.6;
  }
}

.form-group {
  .form-control {
    padding-left: 8px;
  }
}

@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}

/* END MODAL */

/* Pagination */
.paginate {
  display: flex;
}

.paginate .prev {
  background: linear-gradient(90deg, #122549, #203762);
  text-align: right;
  justify-content: flex-end;
}

.paginate .next,
.paginate .prev {
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  width: 50%;
  padding: 0 2em;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
  cursor: pointer;
  transition: padding 0.5s cubic-bezier(0.19, 1, 0.22, 1);
}

button {
  outline: 0;
}

/* .next i {
  margin-left: 10px !important;
  transition: ease-in-out 0.4s;
} */

/* .next:hover i {
  margin-left: 20px !important;
  transition: all 0.4s;
} */

/* .prev i {
  margin-right: 10px !important;
  transition: ease-in-out 0.4s;
} */

/* .prev:hover i {
  margin-right: 20px !important;
  transition: ease-in-out 0.4s;
} */

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;

  &:hover {
    color: blueviolet;
  }
}

@media screen and (min-width: 40em) {
  .paginate .next,
  .paginate .prev {
    height: 118px;
    font-size: 32px;
  }
}

select,
input[type='number'],
input[type='text'],
input[type='search'] {
  height: 3rem;
  padding-top: 8px;
  line-height: 1.3;
}

.search-typehead {
  min-height: 3rem !important;
}

.add-job-comments {
  padding-top: 1rem;
}

@media (max-width: 992px) {
  .plan {
    height: auto;
  }
}
</style>
